import SampleMasterScreen from "components/modules/sample-module/masters/SampleMasterScreen";
import SampleMasterScreenTabbed from "components/modules/sample-module/masters/SampleMasterScreenTabbed";
import PropertyMasterScreen from "components/modules/property-module/masters/PropertyMasterScreen";
import RoomCategoryMasterScreen from "components/modules/room-category-module/masters/RoomCategoryMasterScreen";
import RoomMasterScreen from "components/modules/room-module/masters/RoomMasterScreen";
import MealPlanMasterScreen from "components/modules/meal-plan-module/masters/MealPlanMasterScreen";
import AddonMasterScreen from "components/modules/addon-module/masters/AddonMasterScreen";
import RatePlanMasterScreen from "components/modules/rate-plan-module/masters/RatePlanMasterScreen";
import AgentMasterScreen from "components/modules/agent-module/masters/AgentMasterScreen";
import OtaMasterScreen from "components/modules/ota-module/masters/OtaMasterScreen";
import BankAccountMasterScreen from "components/modules/bank-account-module/masters/BankAccountMasterScreen";
import TaxMastersHost from "components/modules/tax-module/TaxMastersHost";
import TaxRegistrationsScreen from "components/modules/tax-module/TaxRegistrationsScreen";
import SetupChecklistScreen from "components/modules/setup-module/SetupChecklistScreen";
import ConfigReportScreen from "components/modules/setup-module/ConfigReportScreen";
import ChargeTaxMappingsScreen from "components/modules/tax-module/ChargeTaxMappingsScreen";
import ChargeTypesScreen from "components/modules/pms-module/ChargeTypesScreen";
import DocumentSeriesScreen from "components/modules/pms-module/DocumentSeriesScreen";
import PrintLayoutsScreen from "components/modules/pms-module/PrintLayoutsScreen";
import InHouseGuestsScreen from "components/modules/pms-module/InHouseGuestsScreen";
import NightAuditScreen from "components/modules/pms-module/NightAuditScreen";
import AuditCorrectionsScreen from "components/modules/pms-module/AuditCorrectionsScreen";
import InvoicesScreen from "components/modules/pms-module/InvoicesScreen";
import CollectionReportScreen from "components/modules/reports-module/CollectionReportScreen";
import GuestLedgerReportScreen from "components/modules/reports-module/GuestLedgerReportScreen";
import WaiverReportScreen from "components/modules/reports-module/WaiverReportScreen";
import CheckoutRegisterReportScreen from "components/modules/reports-module/CheckoutRegisterReportScreen";
// Front Office daily collection and closing (PMS slice 7d)
import FrontOfficeClosingScreen from "components/modules/pms-module/FrontOfficeClosingScreen";
import FoCollectionReportScreen from "components/modules/reports-module/FoCollectionReportScreen";
// Meal forecast and unused package meals (buffet check-off slice 4)
import MealForecastReportScreen from "components/modules/reports-module/MealForecastReportScreen";
import UnusedMealReportScreen from "components/modules/reports-module/UnusedMealReportScreen";
// Org Admin (PMS slice 4b, ported from EnterpriseTemplates)
import EntityMasterScreen from "components/modules/organisation-module/masters/EntityMasterScreen";
import BusinessUnitMasterScreen from "components/modules/organisation-module/masters/BusinessUnitMasterScreen";
import FinancialYearMasterScreen from "components/modules/organisation-module/masters/FinancialYearMasterScreen";
import AdvancePaymentsScreen from "components/modules/payment-module/masters/AdvancePaymentsScreen";
import CorporateMasterScreen from "components/modules/corporate-module/masters/CorporateMasterScreen";
import GuestMasterScreen from "components/modules/guest-module/masters/GuestMasterScreen";
import PropertyTermsMasterScreen from "components/modules/property-module/masters/PropertyTermsMasterScreen";
import BookingListScreen from "components/modules/booking-module/masters/BookingListScreen";
import AvailabilityScreen from "components/modules/booking-module/masters/AvailabilityScreen";
import ShortageBoardScreen from "components/modules/booking-module/masters/ShortageBoardScreen";
import FrontOfficeWorkspace from "components/modules/frontoffice-module/FrontOfficeWorkspace";
import ApprovalInboxScreen from "components/modules/approval-module/ApprovalInboxScreen";
import ConfigSettingsScreen from "components/modules/config-module/ConfigSettingsScreen";
import RolePermissionsScreen from "components/modules/iam-module/masters/RolePermissionsScreen";
import LedgerMappingScreen from "components/modules/ledger-mapping-module/masters/LedgerMappingScreen";
import PostingRegisterScreen from "components/modules/ledger-mapping-module/masters/PostingRegisterScreen";
// Dashboards & Reports (Phase 1 skeleton)
import DashboardScreen from "components/modules/dashboard-module/DashboardScreen";
import BookingRegisterReportScreen from "components/modules/reports-module/BookingRegisterReportScreen";
import ComplimentaryReportScreen from "components/modules/reports-module/ComplimentaryReportScreen";
import DiscountReportScreen from "components/modules/reports-module/DiscountReportScreen";
import MinRateViolationReportScreen from "components/modules/reports-module/MinRateViolationReportScreen";
import MealPlanRevenueReportScreen from "components/modules/reports-module/MealPlanRevenueReportScreen";
import ExtraPaxReportScreen from "components/modules/reports-module/ExtraPaxReportScreen";
import ForwardOccupancyReportScreen from "components/modules/reports-module/ForwardOccupancyReportScreen";
import AgentCorporateReportScreen from "components/modules/reports-module/AgentCorporateReportScreen";
import DailyMonthlySummaryReportScreen from "components/modules/reports-module/DailyMonthlySummaryReportScreen";
import OccupancyChartReportScreen from "components/modules/reports-module/OccupancyChartReportScreen";
import CheckinDetailsReportScreen from "components/modules/reports-module/CheckinDetailsReportScreen";
// DineOps (restaurant module). Cycle 0 registers the three cycle-1 surfaces so
// the route, the menu entry and the module gate can be exercised end to end
// before there is a body behind them. The catalogue of every DineOps screen —
// including the kitchen display and the separate waiter app — is
// components/modules/dineops-module/dineOpsScreens.ts, which is the one place
// screen codes and module codes are written down.
import DineOpsMenuItemsScreen from "components/modules/dineops-module/masters/DineOpsMenuItemsScreen";
import DineOpsAddonGroupsScreen from "components/modules/dineops-module/masters/DineOpsAddonGroupsScreen";
import DineOpsOutletSetupScreen from "components/modules/dineops-module/masters/DineOpsOutletSetupScreen";
import {
  DineOpsDepartmentsScreen,
  DineOpsTablesScreen,
  DineOpsSectionsScreen,
  DineOpsQuickNotesScreen,
} from "components/modules/dineops-module/masters/DineOpsSetupScreens";
import DineOpsOutletsScreen from "components/modules/dineops-module/masters/DineOpsOutletsScreen";
import DineOpsOutletItemsScreen from "components/modules/dineops-module/masters/DineOpsOutletItemsScreen";
import DineOpsPriceBoardScreen from "components/modules/dineops-module/masters/DineOpsPriceBoardScreen";
import DineOpsBillingPointsScreen from "components/modules/dineops-module/masters/DineOpsBillingPointsScreen";
import DineOpsKitchensScreen from "components/modules/dineops-module/masters/DineOpsKitchensScreen";
import DineOpsRequisitionsScreen from "components/modules/dineops-module/requisitions/DineOpsRequisitionsScreen";
import DineOpsRequisitionRegisterScreen from "components/modules/dineops-module/requisitions/DineOpsRequisitionRegisterScreen";
import DineOpsBillRegisterScreen from "components/modules/dineops-module/reports/DineOpsBillRegisterScreen";
import DineOpsApprovalRulesScreen from "components/modules/dineops-module/masters/DineOpsApprovalRulesScreen";
// Print module (KOT printing): printers, Print Agents and the print queue.
import PrintersScreen from "components/modules/print-module/PrintersScreen";
import PrintAgentsScreen from "components/modules/print-module/PrintAgentsScreen";
import PrintQueueScreen from "components/modules/print-module/PrintQueueScreen";
import { DineOpsKitchenDisplayScreen } from "components/modules/dineops-module/kitchen/KitchenDisplayScreen";
import DineOpsTagsScreen from "components/modules/dineops-module/masters/DineOpsTagsScreen";
import DineOpsSpecialsScreen from "components/modules/dineops-module/masters/DineOpsSpecialsScreen";
import DineOpsPriceListsScreen from "components/modules/dineops-module/masters/DineOpsPriceListsScreen";
import DineOpsBillQueueScreen from "components/modules/dineops-module/cashier/DineOpsBillQueueScreen";
import DineOpsSalesReportScreen from "components/modules/dineops-module/reports/DineOpsSalesReportScreen";
import DineOpsDashboardScreen from "components/modules/dineops-module/reports/DineOpsDashboardScreen";
import DineOpsSettlementReportScreen from "components/modules/dineops-module/reports/DineOpsSettlementReportScreen";
import DineOpsWastageReportScreen from "components/modules/dineops-module/reports/DineOpsWastageReportScreen";
import DineOpsComplaintsReportScreen from "components/modules/dineops-module/reports/DineOpsComplaintsReportScreen";
import DineOpsKitchenReportScreen from "components/modules/dineops-module/reports/DineOpsKitchenReportScreen";
import DineOpsShiftsScreen from "components/modules/dineops-module/till/DineOpsShiftsScreen";
import DineOpsCorrectionsScreen from "components/modules/dineops-module/till/DineOpsCorrectionsScreen";
import DineOpsDayCloseScreen from "components/modules/dineops-module/till/DineOpsDayCloseScreen";

export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  SampleMasterScreenTabbed: SampleMasterScreenTabbed,
  SampleMasterScreen: SampleMasterScreen,
  // Property Module
  PropertyMasterScreen: PropertyMasterScreen,
  // Room Category Module
  RoomCategoryMasterScreen: RoomCategoryMasterScreen,
  // Room Module
  RoomMasterScreen: RoomMasterScreen,
  // Meal Plan Module
  MealPlanMasterScreen: MealPlanMasterScreen,
  // Add-on Module
  AddonMasterScreen: AddonMasterScreen,
  // Rate Plan Module
  RatePlanMasterScreen: RatePlanMasterScreen,
  // Agent Module
  AgentMasterScreen: AgentMasterScreen,
  // OTA Module
  OtaMasterScreen: OtaMasterScreen,
  // Bank Account Module
  BankAccountMasterScreen: BankAccountMasterScreen,
  // Tax Module
  TaxMastersHost: TaxMastersHost,
  TaxRegistrationsScreen: TaxRegistrationsScreen,
  SetupChecklistScreen: SetupChecklistScreen,
  ConfigReportScreen: ConfigReportScreen,
  ChargeTaxMappingsScreen: ChargeTaxMappingsScreen,
  // PMS Module
  ChargeTypesScreen: ChargeTypesScreen,
  DocumentSeriesScreen: DocumentSeriesScreen,
  PrintLayoutsScreen: PrintLayoutsScreen,
  InHouseGuestsScreen: InHouseGuestsScreen,
  NightAuditScreen: NightAuditScreen,
  AuditCorrectionsScreen: AuditCorrectionsScreen,
  InvoicesScreen: InvoicesScreen,
  CollectionReportScreen: CollectionReportScreen,
  GuestLedgerReportScreen: GuestLedgerReportScreen,
  WaiverReportScreen: WaiverReportScreen,
  CheckoutRegisterReportScreen: CheckoutRegisterReportScreen,
  FrontOfficeClosingScreen: FrontOfficeClosingScreen,
  FoCollectionReportScreen: FoCollectionReportScreen,
  MealForecastReportScreen: MealForecastReportScreen,
  UnusedMealReportScreen: UnusedMealReportScreen,
  // Org Admin Module
  EntityMasterScreen: EntityMasterScreen,
  BusinessUnitMasterScreen: BusinessUnitMasterScreen,
  FinancialYearMasterScreen: FinancialYearMasterScreen,
  // Payment Module
  AdvancePaymentsScreen: AdvancePaymentsScreen,
  // Corporate Module
  CorporateMasterScreen: CorporateMasterScreen,
  // Guest Module
  GuestMasterScreen: GuestMasterScreen,
  // Property Terms Module
  PropertyTermsMasterScreen: PropertyTermsMasterScreen,
  // Booking Module
  BookingListScreen: BookingListScreen,
  AvailabilityScreen: AvailabilityScreen,
  ShortageBoardScreen: ShortageBoardScreen,
  // Front Office Module (E2)
  FrontOfficeWorkspace: FrontOfficeWorkspace,
  // Approval Module
  ApprovalInboxScreen: ApprovalInboxScreen,
  // Config Module
  ConfigSettingsScreen: ConfigSettingsScreen,
  // IAM Module
  RolePermissionsScreen: RolePermissionsScreen,
  // Ledger Mapping (Fairbooks integration)
  LedgerMappingScreen: LedgerMappingScreen,
  PostingRegisterScreen: PostingRegisterScreen,
  // Dashboard Module (Phase 1 skeleton)
  DashboardScreen: DashboardScreen,
  // Reports Module (Phase 1 skeleton)
  BookingRegisterReportScreen: BookingRegisterReportScreen,
  ComplimentaryReportScreen: ComplimentaryReportScreen,
  DiscountReportScreen: DiscountReportScreen,
  MinRateViolationReportScreen: MinRateViolationReportScreen,
  MealPlanRevenueReportScreen: MealPlanRevenueReportScreen,
  ExtraPaxReportScreen: ExtraPaxReportScreen,
  ForwardOccupancyReportScreen: ForwardOccupancyReportScreen,
  AgentCorporateReportScreen: AgentCorporateReportScreen,
  DailyMonthlySummaryReportScreen: DailyMonthlySummaryReportScreen,
  // Operational reports (July 2026)
  OccupancyChartReportScreen: OccupancyChartReportScreen,
  CheckinDetailsReportScreen: CheckinDetailsReportScreen,
  // DineOps Module (restaurant)
  DineOpsMenuItemsScreen: DineOpsMenuItemsScreen,
  DineOpsAddonGroupsScreen: DineOpsAddonGroupsScreen,
  DineOpsOutletSetupScreen: DineOpsOutletSetupScreen,
  DineOpsDepartmentsScreen: DineOpsDepartmentsScreen,
  DineOpsTablesScreen: DineOpsTablesScreen,
  DineOpsSectionsScreen: DineOpsSectionsScreen,
  DineOpsQuickNotesScreen: DineOpsQuickNotesScreen,
  DineOpsOutletsScreen: DineOpsOutletsScreen,
  DineOpsOutletItemsScreen: DineOpsOutletItemsScreen,
  DineOpsPriceBoardScreen: DineOpsPriceBoardScreen,
  DineOpsBillingPointsScreen: DineOpsBillingPointsScreen,
  DineOpsKitchensScreen: DineOpsKitchensScreen,
  DineOpsRequisitionsScreen: DineOpsRequisitionsScreen,
  DineOpsRequisitionRegisterScreen: DineOpsRequisitionRegisterScreen,
  DineOpsBillRegisterScreen: DineOpsBillRegisterScreen,
  DineOpsApprovalRulesScreen: DineOpsApprovalRulesScreen,
  PrintersScreen: PrintersScreen,
  PrintAgentsScreen: PrintAgentsScreen,
  PrintQueueScreen: PrintQueueScreen,
  DineOpsKitchenDisplayScreen: DineOpsKitchenDisplayScreen,
  DineOpsTagsScreen: DineOpsTagsScreen,
  DineOpsSpecialsScreen: DineOpsSpecialsScreen,
  DineOpsPriceListsScreen: DineOpsPriceListsScreen,
  DineOpsBillQueueScreen: DineOpsBillQueueScreen,
  DineOpsSalesReportScreen: DineOpsSalesReportScreen,
  DineOpsDashboardScreen: DineOpsDashboardScreen,
  DineOpsSettlementReportScreen: DineOpsSettlementReportScreen,
  DineOpsWastageReportScreen: DineOpsWastageReportScreen,
  DineOpsComplaintsReportScreen: DineOpsComplaintsReportScreen,
  DineOpsKitchenReportScreen: DineOpsKitchenReportScreen,
  DineOpsShiftsScreen: DineOpsShiftsScreen,
  DineOpsCorrectionsScreen: DineOpsCorrectionsScreen,
  DineOpsDayCloseScreen: DineOpsDayCloseScreen,
};